import { FC } from "react";
import { Card } from "react-bootstrap";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as AddAddonSVG } from "../../../../../../../../images/svg/subscriptions/add-addon.svg";
import { PriceConfiguratorAddonApi } from "../../../../../../../../services/Api/types";

interface Props {
	addon: PriceConfiguratorAddonApi;
	handleAdd: (addon: PriceConfiguratorAddonApi, skipRules?: boolean, termsAccepted?: boolean) => void;
}

const UninstalledAddon: FC<Props> = ({ addon, handleAdd }) => {
	const isSmallBreakpoint = useWindowSize().isSmallBreakpoint;

	const drawContent = () => {
		if (isSmallBreakpoint)
			return (
				<div className={"addon-body"}>
					<div className="addon-body-wrapper">
						<h5>{addon.name}</h5>
						<AddAddonSVG className="icon" onClick={() => handleAdd(addon)} />
					</div>
					<div className={"addon-description"}>{addon.description}</div>
				</div>
			);

		return (
			<>
				<div className={"addon-body"}>
					<h5 className={"w-60 addon-body-item"}>{addon.name}</h5>
					<div className={"w-15 addon-body-item"}></div>
					<div className={"w-15 addon-body-item"}></div>
					<div className={"addon-body-item"}>
						<AddAddonSVG onClick={() => handleAdd(addon)} />
					</div>
				</div>
				<div className={"addon-description"}>{addon.description}</div>
			</>
		);
	};

	return (
		<Card className={"uninstalled-addon"}>
			<Card.Body>{drawContent()}</Card.Body>
		</Card>
	);
};
export default UninstalledAddon;
